import styled from "styled-components"

import {
  displayFont,
  GradientText,
  mobileBreakpoint,
  ReferrerBadge,
  tabletBreakpoint,
  tealAccent,
  textGrey,
  useReferralAgent,
} from "./shared"

const HeroLeft = styled.div`
  max-width: 520px;

  @media only screen and (width <= ${tabletBreakpoint}) {
    max-width: none;
  }
`

const HeroTitle = styled.h1`
  /* the page-level reset (h1,h2,h3 { margin: 0 }) can win the specificity tie, so force it */
  margin-top: 24px !important;
  font-family: ${displayFont};
  font-size: 52px;
  font-weight: 700;
  line-height: 1.15;

  @media only screen and (width <= ${mobileBreakpoint}) {
    font-size: 36px;
  }
`

const HeroText = styled.p`
  margin: 16px 0 32px;
  color: ${textGrey};
  font-size: 1rem;
  line-height: 1.6;
`

const Stats = styled.div`
  display: flex;
  gap: 48px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  @media only screen and (width <= ${mobileBreakpoint}) {
    gap: 24px;
  }
`

const StatValue = styled.span`
  color: ${tealAccent};
  font-family: ${displayFont};
  font-size: 1.5rem;
  font-weight: 700;
`

const StatLabel = styled.span`
  color: ${textGrey};
  font-size: 0.75rem;
`

export const HeroIntro = () => {
  const agent = useReferralAgent()
  const firstName = agent?.name.split(" ")[0] ?? "your agent"

  return (
    <HeroLeft>
      <ReferrerBadge />
      <HeroTitle>
        Welcome home.
        <GradientText>
          Your first upgrade
          <br />
          is on us.
        </GradientText>
      </HeroTitle>
      <HeroText>
        {`A free ENERGY STAR smart thermostat, plus professional install. ${firstName} covered it, you keep the ~$140/yr in savings.`}
      </HeroText>
      <Stats>
        <div>
          <StatValue>$0</StatValue>
          <StatLabel>Hardware + install</StatLabel>
        </div>
        <div>
          <StatValue>~$140</StatValue>
          <StatLabel>Saved per year</StatLabel>
        </div>
        <div>
          <StatValue>45 min</StatValue>
          <StatLabel>Install, one visit</StatLabel>
        </div>
      </Stats>
    </HeroLeft>
  )
}
